__webpack_require__.p = "https://widget.24gen.ai/";